export const selectCampaigns = (state) =>
  state.get('cashbackCampaignsContainer').get('campaigns').toJS();
export const selectCampaignsIsLoading = (state) =>
  state.get('cashbackCampaignsContainer').get('campaignsIsLoading');
export const selectCampaignsErrorMessage = (state) =>
  state.get('cashbackCampaignsContainer').get('campaignsErrorMessage');
